import { SVGProps, useId } from 'react';

export const McpCursorIcon = (props: SVGProps<any>) => {
  // Per-instance ids: a shared one makes every copy paint from the first icon's inherited colour.
  const fill = useId().replace(/:/g, '');

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      fillRule="evenodd"
      height="1em"
      viewBox="0 0 24 24"
      width="1em"
      {...props}
    >
      <path d="M11.925 24l10.425-6-10.425-6L1.5 18l10.425 6z" fill={`url(#${fill}-0)`}></path>
      <path d="M22.35 18V6L11.925 0v12l10.425 6z" fill={`url(#${fill}-1)`}></path>
      <path d="M11.925 0L1.5 6v12l10.425-6V0z" fill={`url(#${fill}-2)`}></path>
      <path d="M22.35 6L11.925 24V12L22.35 6z" fill="currentColor" fillOpacity=".67"></path>
      <path d="M22.35 6l-10.425 6L1.5 6h20.85z" fill="currentColor"></path>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${fill}-0`}
          x1="11.925"
          x2="11.925"
          y1="12"
          y2="24"
        >
          <stop offset=".16" stopColor="currentColor" stopOpacity=".39"></stop>
          <stop offset=".658" stopColor="currentColor" stopOpacity=".8"></stop>
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${fill}-1`}
          x1="22.35"
          x2="11.925"
          y1="6.037"
          y2="12.15"
        >
          <stop offset=".182" stopColor="currentColor" stopOpacity=".31"></stop>
          <stop offset=".715" stopColor="currentColor" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${fill}-2`}
          x1="11.925"
          x2="1.5"
          y1="0"
          y2="18"
        >
          <stop stopColor="currentColor" stopOpacity=".6"></stop>
          <stop offset=".667" stopColor="currentColor" stopOpacity=".22"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};
